import {action, observable} from "mobx";

import {BaseModel} from "../../../infrastructure/models/base-model";
import {PartialGameDomainModel} from "../../../domain/partial-game/models/partial-game-domain-model";
import {CompetitionDomainModel} from "../../../domain/common/competition/models/competition-domain-model";
import {CompetitorDomainModel} from "../../../domain/common/competitor/models/competitor-domain-model";
import {singleton} from "../../../infrastructure/decorators/singleton";
import {Type} from "../../../infrastructure/type";
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {EntityDomainModel} from "../../../infrastructure/models/entity/entity.domain-model";
import {makeObservableClass} from "../../../infrastructure/decorators/observable";
import {AthleteDomainModel} from "../../../domain/common/athlete/athlete-domain-model";

@makeObservableClass
@singleton
export class WebsiteModuleEntitiesContext extends BaseModel {
  @observable game: PartialGameDomainModel;
  @observable competition: CompetitionDomainModel;
  @observable competitor: CompetitorDomainModel;
  @observable competitorSquad: Array<AthleteDomainModel>;
  @observable selectedEntityType: Type<EntityDomainModel>;
  @observable athlete: AthleteDomainModel;

  callbacks: Array<Function> = [];
  gameCallbacks: Array<Function> = [];

  setSelectedEntityType(selectedEntityType: Type<EntityViewModel>) {
  }

  @action setCompetition(competition: CompetitionDomainModel) {
    this.competition = competition;

    this.callEntityChange();
  }

  @action setCompetitor(competitor: CompetitorDomainModel) {
    this.competitor = competitor;

    this.callEntityChange();
  }

  @action setAthlete(athlete: AthleteDomainModel) {
    this.athlete = athlete;

    this.callEntityChange();
  }

  @action setCompetitorSquad(competitorSquad: Array<AthleteDomainModel>) {
    this.competitorSquad = competitorSquad?.map((athlete: AthleteDomainModel) => athlete);

    this.callbacks.forEach(callbackObject => callbackObject.callback());
  }

  @action setGame(game: PartialGameDomainModel) {
    this.game = game;

    if(game) {
      this.activateGameExistCallbacks()
    }

    this.callEntityChange();
  }

  @action clear() {
    this.game = null;
    this.competition = null;
    this.competitor = null;
    this.competitorSquad = null;
    this.athlete = null;
  }

  registerToContextChange(id, callback) {
    const existingCallback = this.callbacks.find(callbackObject => callbackObject.id === id);

    if (!existingCallback) {
      this.callbacks.push({id, callback});
    }
  }

  removeCallback(id) {
    this.callbacks = this.callbacks.filter(callbackObject => callbackObject.id !== id);
  }

  callEntityChange() {
    this.callbacks.forEach(callbackObject => callbackObject.callback());
  }

  registerToGameExist(id, callback) {
    const existingCallback = this.gameCallbacks.find(callbackObject => callbackObject.id === id);

    if (!existingCallback) {
      this.gameCallbacks.push({id, callback});
    }
  }

  activateGameExistCallbacks() {
    this.gameCallbacks.forEach(callbackObject => callbackObject.callback());
  }

  removeGameCallback(id) {
    this.gameCallbacks = this.gameCallbacks.filter(callbackObject => callbackObject.id !== id);
  }
}
